<template>
  <div>
    <template v-if="pms">
      <space-management />
    </template>
    <no-pms v-else></no-pms>
  </div>
</template>

<script>
import mixin from "./components/Mixins";
import components from "./components";
import NoPms from "@/components/NoPms.vue";

export default {
  mixins: [components, mixin],

  components: { NoPms },

  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms = pms["50000"].check;
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceManagement/index.vue